// Admin\src\components\qoutes\Qoutes.js

import React, { useEffect, useState } from 'react'
import { Delete, Pencil } from '../../common/Icons'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { toaster } from '../../apis/commonFunctions'
import { deleteRequest, getRequest, patchRequest, postRequest } from '../../apis/functions'
import APIS from '../../apis/routes'
import NoDataRow from '../../common/NoDataRow'
import LoadingRow from '../../common/LoadingRow'
import Pagination from '../../common/Pagination'
import moment from 'moment/moment'

export default function Qoutes() {
    const [all, setAll] = useState([]);
    const router = useNavigate();
    const [skip, setSkip] = useState(0);
    const [type, setType] = useState(1);   // 1 = Quote, 2 = Affirmation
    const [limit, setLimit] = useState(8);
    const [mainId, setMainId] = useState("");
    const [total, setTotal] = useState(0);
    const [params] = useSearchParams();
    const search = params.get('search') || "";
    const [loading, setLoading] = useState(false);

    // For the "Add" modal
    const [modalType, setModalType] = useState(1); // 1 = Quote, 2 = Affirmation
    const [title, setTitle] = useState("");
    const [writtenBy, setWrittenBy] = useState("");

    // New state for the "Edit" modal
    const [editData, setEditData] = useState({
        id: "",
        modalType: 1,
        title: "",
        writtenBy: ""
    });

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getRequest(
                `${APIS.GET_QUOTES_AFFIRMATION}?search=${search}&skip=${skip}&limit=${limit}`
            );
            setLoading(false);
            if (!result.data.status) {
                toaster(result.data.message, false);
            } else {
                setAll(result.data.data);
                setTotal(result.data.total_count);
            }
        } catch (err) {
            toaster(err.message, false);
            setLoading(false);
        }
    };

    function handlePageClick({ selected }) {
        setSkip(selected * limit);
    }

    const hanldeType = (value) => {
        setType(Number(value));
    };

    // Filter the array based on the selected type (1 = Quote, 2 = Affirmation)
    const [data, setData] = useState([]);
    useEffect(() => {
        setData([...all.filter((item) => item.type === type)]);
    }, [all, type]);

    useEffect(() => {
        fetchData();
    }, [search, skip]);

    // Handle Add button in modal
    const handleAddNew = async () => {
        try {
            // Construct the payload
            const payload = {
                type: modalType,     // 1 or 2
                title,
            };
            // If type is 1 (Quote), include 'write_by'
            if (modalType === 1) {
                payload.write_by = writtenBy;
            }

            // Make POST request to create a new Quote or Affirmation
            const result = await postRequest(APIS.POST_QUOTES_AFFIRMATION, payload);

            if (result.data.status) {
                toaster(result.data.message, true);
                // Close the modal manually
                const closeBtn = document.getElementById("closeAddModal");
                if (closeBtn) closeBtn.click();

                // Clear form
                setTitle("");
                setWrittenBy("");
                setModalType(1);

                // Refresh data
                fetchData();
            } else {
                toaster(result.data.message, false);
            }
        } catch (err) {
            toaster(err.message, false);
        }
    };

    const handleEdit = (quote) => {
        setEditData({
            id: quote._id,
            modalType: quote.type,
            title: quote.title,
            writtenBy: quote.write_by || ""
        });
    };

    const handleUpdate = async () => {
        try {
            const payload = {
                type: editData.modalType,
                title: editData.title,
                id: editData.id
            };
            if (editData.modalType === 1) {
                payload.write_by = editData.writtenBy;
            }
            const result = await patchRequest(APIS.PATCH_QUOTES_AFFIRMATION, payload);
            if (result.data.status) {
                toaster(result.data.message, true);
                const closeBtn = document.getElementById("closeEditModal");
                if (closeBtn) closeBtn.click();
                fetchData();
            } else {
                toaster(result.data.message, false);
            }
        } catch (err) {
            toaster(err.message, false);
        }
    };

    // New delete handler
    const handleDelete = async () => {
        try {
            // Assuming the delete endpoint expects the ID in the URL
            const result = await deleteRequest(`${APIS.DELETE_QUOTES_AFFIRMATION}/${mainId}`);
            if (result.data.status) {
                toaster(result.data.message, true);
                fetchData();
            } else {
                toaster(result.data.message, false);
            }
        } catch (err) {
            toaster(err.message, false);
        }
    };

    return (
        <>
            <div className="top_bar row align-items-center mt-3">
                <div className="col-lg-6">
                    <div className="pagetitle">
                        Quotes Affirmation Management <br />
                    </div>
                </div>
                <div className="col-lg-6 d-flex justify-content-end">
                    {/* The Add button triggers the modal */}
                    <button
                        className="btn btn-success me-3"
                        data-bs-toggle="modal"
                        data-bs-target="#addModal"
                    >
                        Add
                    </button>
                    <select
                        name="type"
                        id="type"
                        className="form-select"
                        style={{ maxWidth: '250px' }}
                        onChange={(e) => hanldeType(e.target.value)}
                        value={type}
                    >
                        <option value={1}>Quotes</option>
                        <option value={2}>Affirmation</option>
                    </select>
                </div>
            </div>

            <div className="row mt-5">
                <div className="table-responsive">
                    <table className="table table-lg">
                        <thead className="table-light">
                            <tr>
                                <th>S.No</th>
                                <th>Title</th>
                                {type === 1 && <th>Written By</th>}
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data && data.length > 0 &&
                                data.map((element, index) => (
                                    <tr key={element._id}>
                                        <td>{index + 1}</td>
                                        <td style={{ textTransform: "inherit" }}>{element.title}</td>
                                        {type === 1 && (
                                            <td style={{ textTransform: "unset" }}>
                                                {element.write_by}
                                            </td>
                                        )}
                                        <td style={{ textTransform: "unset" }}>
                                            {moment(element.createdAt).format("DD MMM YYYY")}
                                        </td>
                                        <td>
                                            <div className="actions">
                                                <button
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#editModal"
                                                    onClick={() => handleEdit(element)}
                                                >
                                                    <Pencil />
                                                </button>
                                                <button
                                                    className="delete"
                                                    onClick={() => setMainId(element._id)}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#deleteModal"
                                                >
                                                    <Delete />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }

                            {!loading && data.length <= 0 && <NoDataRow />}
                            {loading && <LoadingRow />}

                            {total > limit && (
                                <tr className="text-center">
                                    <td colSpan={20}>
                                        <Pagination
                                            handlePageClick={handlePageClick}
                                            totalCount={total}
                                            limit={limit}
                                        />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ------------------ Add Modal ------------------ */}
            <div
                className="modal fade"
                id="addModal"
                tabIndex="-1"
                aria-labelledby="addModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title" id="addModalLabel">
                                Add {modalType === 1 ? "Quote" : "Affirmation"}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="closeAddModal"
                            ></button>
                        </div>

                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="modalTypeSelect" className="form-label">
                                    Select Type
                                </label>
                                <select
                                    className="form-select"
                                    id="modalTypeSelect"
                                    value={modalType}
                                    onChange={(e) => setModalType(Number(e.target.value))}
                                >
                                    <option value={1}>Quote</option>
                                    <option value={2}>Affirmation</option>
                                </select>
                            </div>

                            <div className="mb-3">
                                <label htmlFor="titleInput" className="form-label">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="titleInput"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    placeholder="Enter the text..."
                                />
                            </div>

                            {modalType === 1 && (
                                <div className="mb-3">
                                    <label htmlFor="writtenByInput" className="form-label">
                                        Written By
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="writtenByInput"
                                        value={writtenBy}
                                        onChange={(e) => setWrittenBy(e.target.value)}
                                        placeholder="Enter the author's name..."
                                    />
                                </div>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleAddNew}
                                disabled={!title}
                            >
                                Save
                            </button>
                        </div>

                    </div>
                </div>
            </div>
            {/* ------------------ End Add Modal ------------------ */}

            {/* ------------------ Edit Modal ------------------ */}
            <div
                className="modal fade"
                id="editModal"
                tabIndex="-1"
                aria-labelledby="editModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title" id="editModalLabel">
                                Edit {editData.modalType === 1 ? "Quote" : "Affirmation"}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="closeEditModal"
                            ></button>
                        </div>

                        <div className="modal-body">

                            <div className="mb-3">
                                <label htmlFor="editTitleInput" className="form-label">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="editTitleInput"
                                    value={editData.title}
                                    onChange={(e) =>
                                        setEditData({ ...editData, title: e.target.value })
                                    }
                                    placeholder="Enter the text..."
                                />
                            </div>

                            {editData.modalType === 1 && (
                                <div className="mb-3">
                                    <label htmlFor="editWrittenByInput" className="form-label">
                                        Written By
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="editWrittenByInput"
                                        value={editData.writtenBy}
                                        onChange={(e) =>
                                            setEditData({ ...editData, writtenBy: e.target.value })
                                        }
                                        placeholder="Enter the author's name..."
                                    />
                                </div>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleUpdate}
                                disabled={!editData.title}
                            >
                                Update
                            </button>
                        </div>

                    </div>
                </div>
            </div>
            {/* ------------------ End Edit Modal ------------------ */}

            {/* ------------------ Delete Confirmation Modal ------------------ */}
            <div
                className="modal fade"
                id="deleteModal"
                tabIndex="-1"
                aria-labelledby="deleteModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteModalLabel">Confirm Deletion</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            Are you sure you want to delete this item?
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                data-bs-dismiss="modal"
                                onClick={handleDelete}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* ------------------ End Delete Confirmation Modal ------------------ */}
        </>
    );
}




// import React, { useEffect, useMemo, useState } from 'react'
// import { Block, Calculator, Delete, Eye, Pencil, Search } from '../../common/Icons'
// import { Link, useNavigate, useSearchParams } from 'react-router-dom'
// import { toaster } from '../../apis/commonFunctions'
// import { deleteRequest, getRequest, patchRequest } from '../../apis/functions'
// import APIS from '../../apis/routes'
// import NoDataRow from '../../common/NoDataRow'
// import LoadingRow from '../../common/LoadingRow'
// import Button from '../../common/Button'
// import Switch from "react-switch";
// import ConfirmationPopup from '../../common/popups/ConfirmationPopup'
// import Pagination from '../../common/Pagination'
// import Search_input from '../../common/Search_input'
// import moment from 'moment/moment'



// export default function Qoutes() {
//     const [all, setAll] = useState([]);
//     const router = useNavigate()
//     const [skip, setSkip] = useState(0)
//     const [type, setType] = useState(1)
//     const [limit, setLimit] = useState(8);
//     const [mainid, setMainId] = useState("");
//     const [total, setTotal] = useState(0)
//     const [params] = useSearchParams();
//     // console.log(Array.from(params.entries())," thishsishihsih")
//     const search = params.get('search')
//     const [loading, setLoading] = useState(false);


//     const fetchData = async () => {
//         try {
//             setLoading(true);
//             const result = await getRequest(`${APIS.GET_QUOTES_AFFIRMATION}?search=${search ?? ""}&skip=${skip}&limit=${limit}`);
//             setLoading(false);
//             if (!result.data.status) {
//                 toaster(result.data.message, false)
//             } else {
//                 setAll(result.data.data)
//                 setTotal(result.data.total_count)

//             }
//         } catch (err) {
//             toaster(err.message, false);
//         }
//     }

//     function handlePageClick({ selected }) {
//         setSkip(selected * limit)
//     }

//     const hanldeType = (value) => {
//         setType(value)
//     }


//     useEffect(() => {
//         fetchData();
//     }, [search, skip]);

//     const [data, setData] = useState([])

//     useEffect(() => {
//         console.log(type, " my type")
//         setData([...all.filter(item => item.type == type)])
//     }, [all, type]);


//     return (
//         <>
//             <div className="top_bar row align-items-center mt-3">
//                 <div className="col-lg-6">
//                     <div className="pagetitle">
//                         Qoutes Affirmation Management <br />
//                     </div>
//                 </div>
//                 <div className="col-lg-6 d-flex justify-content-end">
//                     <button className="btn btn-success me-3">Add</button>
//                     <select name="type" id="type" className='form-select' style={{ maxWidth: '250px' }} onChange={(e) => hanldeType(e.target.value)}>
//                         <option value={1}>Quotes</option>
//                         <option value={2}>Affirmation</option>
//                     </select>
//                 </div>
//             </div>
//             <div className="row mt-5">
//                 <div className="table-responsive">
//                     <table className='table table-lg'>
//                         <thead className='table-light'>
//                             <tr colSpan="4">
//                                 <th>S.No</th>
//                                 <th>Title</th>
//                                 {type == 1 && <th>Written By</th>}
//                                 <th>Date</th>
//                                 <th>Action</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {data && data.length > 0
//                                 &&
//                                 data.map((element, index) => {
//                                     console.log(element, " my element");
//                                     return <tr key={element._id}>
//                                         <td>{index + 1}</td>
//                                         <td style={{ textTransform: "inherit" }}>{element.title}</td>
//                                         {type == 1 && <td style={{ textTransform: "unset" }}>{element.write_by}</td>}
//                                         <td style={{ textTransform: "unset" }}>{moment(element.createdAt).format("DD MMM YYYY")}</td>
//                                         <td>
//                                             <div className="actions">
//                                                 {/* <button className='view p-2'>
//                                                     <Link className='view' to={'/user-management/' + element._id}>
//                                                         <Eye />
//                                                     </Link>
//                                                 </button> */}
//                                                 {/* <button className='view p-2'>
//                                                 <Link className='view' to={'/user-emi-management/' + element._id}>
//                                                     <Calculator />
//                                                 </Link>
//                                             </button> */}
//                                                 {/* <button className='block' onClick={() => { blockUnblockUser(element._id) }} style={{ color: (element.admin_blocked ? "#0F993E" : "#ff4c27") }}>
//                                                 <Block />
//                                             </button> */}
//                                                 <button className='delete' onClick={() => setMainId(element._id)} data-bs-toggle="modal" data-bs-target="#decline_modal">
//                                                     <Delete />
//                                                 </button>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 })}
//                             {!loading && data.length <= 0 && <NoDataRow />}

//                             {loading && <LoadingRow />}
//                             {total > limit && <tr className='text-center'><td colSpan={20}><Pagination handlePageClick={handlePageClick} totalCount={total} limit={limit} /></td></tr>}

//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </>
//     )
// }
